// extracted by mini-css-extract-plugin
export default {"skeleton":"zgcLsp","dissolve":"j8Flf_"};